import React, { useContext } from 'react';

export interface PortalContextType {
  portalType: string;
  tenant: string;
  apiType: string;

  activePortal: string;
  setActivePortal: (portal: string) => void;
}

const PortalContext = React.createContext<PortalContextType | undefined>(undefined);

/**
 * Custom hook to consume portal data from the PortalContext.
 * @returns {any} The portal context data.
 */
export const usePortal = (): PortalContextType => {
  const context = useContext(PortalContext);

  if (context === undefined) {
    throw new Error('usePortal must be used within a PortalProvider');
  }

  return context;
};

export default PortalContext;
